import { atom } from 'recoil';

const unReadMessageCountAtom = atom({
    key: 'unreadMessageCount',
    default: 0
});

export {
    unReadMessageCountAtom
};